import store from "src/Reducers/store";
import * as appActions from "src/Actions/appActions";

const setCurrentPage = (pageIndex: string) => store.dispatch(appActions.setCurrentPage(pageIndex));

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "historical-data",
    iconColor: "white",
    text: "Personalized \ncommand center \ndashboards \nbased on real-\ntime and \nhistorical data",
    listItemCustomStyle: { width: "180px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "deep-dive",
    iconColor: "white",
    text: "Deep dive into \nend-to-end order \njourney using \nEPV",
    listItemCustomStyle: { width: "180px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "proactive-communication",
    iconColor: "white",
    text: "Proactive \ncommunication through any \nchannel of choice",
    listItemCustomStyle: { width: "180px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "like-finger",
    iconColor: "white",
    text: "Customer and\n agent satisfaction",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

const data = {
  styleLeftPanel: { paddingRight: 0 },
  title: "Autonomous Business \nOperation",
  text: "Experience near real-time End-to-end process visibility on-demand, with \nproactive communication.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  styleListData: { marginTop: "-20px" },
  next: {
    label: "FIND OUT HOW",
    onClick: () => setCurrentPage("ILO_102"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_2"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO1/ILO1_Introduction_01.png",
};

export default data;
